import i18n from "@/i18n";
import ChartService from "@/services/charts/ChartService";
import WDService from "@/services/wind/diagnostic/WindDiagnosticService";
import ElectricFailController from "@/controllers/wind/diagnostic/ElectricFailController.js";
import { SetLayoutLinesColor } from "@/components/charts/ChartStyles";
import {
	GET_ELECTRIC_FAIL_RESULT,
	GET_ELECTRIC_FAIL_RESULT_SUCCESS,
	GET_ELECTRIC_FAIL_RESULT_ERROR,
	GET_ELECTRIC_FAIL_CHART,
	GET_ELECTRIC_FAIL_CHART_SUCCESS,
	GET_ELECTRIC_FAIL_CHART_ERROR,
	RESET_ELECTRIC_FAIL_RESULT,
} from "./ElectricFailActionTypes.js";

function SortByName(arrayToSort)
{
	arrayToSort.sort((a, b) =>
	{
		const nameA = a.name.toUpperCase();
		const nameB = b.name.toUpperCase();
		if (nameA < nameB)
		{
			return -1;
		}
		if (nameA > nameB)
		{
			return 1;
		}
		return 0;
	});
};

const ElectricFailLayout = () =>
{
	const layout = {
		annotations:   [],
		paper_bgcolor: "rgba(0,0,0,0)",
		plot_bgcolor:  "rgba(0,0,0,0)",
		color:         "",
		showlegend:    true,
		shapes:        [],
		legend:        {
			x:           0,
			y:           1.2,
			orientation: "h",
			font:        {
				family: "Segoe UI",
				size:   18,
				color:  "",
			},
		},
		margin: {
			l:   70,
			r:   40,
			b:   50,
			t:   0,
			pad: 0,
		},
		xaxis: { title: i18n.t("Labels.XAxisName") },
		yaxis: { title: i18n.t("Labels.YAxisNameG") },
	};
	return layout;
};

const actions = {
	[GET_ELECTRIC_FAIL_RESULT]: ({ commit }, resultSetId) => new Promise((resolve, reject) =>
	{
		commit(GET_ELECTRIC_FAIL_RESULT);

		ElectricFailController.GetElectricFailResult(resultSetId)
			.then((response) =>
			{
				commit(GET_ELECTRIC_FAIL_RESULT_SUCCESS, response);
				resolve(response);
			})
			.catch((error) =>
			{
				commit(GET_ELECTRIC_FAIL_RESULT_ERROR, error);
				reject(error);
			});
	}),

	[RESET_ELECTRIC_FAIL_RESULT]: ({ commit }) =>
	{
		commit(RESET_ELECTRIC_FAIL_RESULT);
	},

	[GET_ELECTRIC_FAIL_CHART]: async({ commit }, parameters) =>
	{
		commit(GET_ELECTRIC_FAIL_CHART);
	
		try
		{
			const response = await ElectricFailController.GetElectricFailChartData(parameters.resultSetId);
			
			SortByName(response.electricFailureGeneratorRawChart);
			SortByName(response.electricFailureGeneratorEnvelopeChartsView);
	
			const rawOrderChartData = WDService.CreateChart(response.electricFailureGeneratorRawChart, true);
			const envelopeOrderChartData = WDService.CreateChart(response.electricFailureGeneratorEnvelopeChartsView, true);
			const rawFrequencyChartData = WDService.CreateChart(response.electricFailureGeneratorRawChart, false);
			const envelopeFrequencyChartData = WDService
				.CreateChart(response.electricFailureGeneratorEnvelopeChartsView, false);
	
			const orderLayout = SetLayoutLinesColor(ElectricFailLayout(), parameters.isDarkMode);
			const frequencyLayout = SetLayoutLinesColor(ElectricFailLayout(), parameters.isDarkMode);
	
			const envelopeOrderShapes = ChartService
				.CreateAnnotations(response.envelopeConcernOrders);
			const envelopeOrderAnnotations = ChartService
				.CreateAnnotationText(response.envelopeConcernOrders, parameters.isDarkMode, "FREQ GEN");
			const envelopeFrequencyShapes = ChartService
				.CreateAnnotations(response.envelopeConcernFrequencies);
			const envelopeFrequencyAnnotations = ChartService
				.CreateAnnotationText(response.envelopeConcernFrequencies, parameters.isDarkMode, "FREQ GEN");
	
			const rawOrderShapes = ChartService.CreateAnnotations(response.rawConcernOrders);
			const rawOrderAnnotations = ChartService
				.CreateAnnotationText(response.rawConcernOrders, parameters.isDarkMode, "120Hz");
			const rawFrequencyShapes = ChartService
				.CreateAnnotations(response.rawConcernFrequencies);
			const rawFrequencyAnnotations = ChartService
				.CreateAnnotationText(response.rawConcernFrequencies, parameters.isDarkMode, "120Hz");
	
			orderLayout.shapes = envelopeOrderShapes.concat(rawOrderShapes);
			orderLayout.annotations = envelopeOrderAnnotations.concat(rawOrderAnnotations);
	
			frequencyLayout.shapes = envelopeFrequencyShapes.concat(rawFrequencyShapes);
			frequencyLayout.annotations = envelopeFrequencyAnnotations.concat(rawFrequencyAnnotations);
	
			frequencyLayout.xaxis.title = "Frequência [Hz]";
	
			const resp = {
				rawOrderChartData,
				rawFrequencyChartData,
				envelopeOrderChartData,
				envelopeFrequencyChartData,
				orderLayout,
				frequencyLayout,
			};
	
			commit(GET_ELECTRIC_FAIL_CHART_SUCCESS, resp);
			return resp;
		}
		catch (error)
		{
			commit(GET_ELECTRIC_FAIL_CHART_ERROR, error);
		}
	}
};

export default { actions };
